<template>
  <div class="ui-rest-table__pagination">
    <UiStack justify="space-between" wrap>
      <RestTableItemsPerPage
        v-model="perPageModel"
        :per-page-options="perPageOptions"
        :attach-dropdown-to-body="itemsPerPageAttachDropdownToBody"
        size="md"
      />
      <UiPagination
        v-if="totalItems > filters.per_page"
        v-model="pageModel"
        :per-page="filters.per_page"
        :total-items="totalItems"
        size="sm"
      />
    </UiStack>
  </div>
</template>

<script setup>
import RestTableItemsPerPage from "./RestTableItemsPerPage.vue";

const perPageModel = defineModel("perPageModel", {
  type: Number,
  required: true,
});
const pageModel = defineModel("pageModel", {
  type: Number,
  required: true,
});

const {
  totalItems = undefined,
  perPageOptions = undefined,
  filters = {},
  itemsPerPageAttachDropdownToBody,
} = defineProps({
  totalItems: Number,
  /** @perPageOptions is number[] */
  perPageOptions: Array,
  filters: Object,
  itemsPerPageAttachDropdownToBody: Boolean,
});
</script>

<style lang="scss" scoped>
.ui-rest-table__pagination {
  border-top: 1px solid var(--bb-gray-900); // current table border
  padding: 1.3rem;
  position: sticky;
  bottom: 0;
  margin-top: -1px; // preventing a double-border effect when the element is not sticky

  &::before {
    // for bg hex color opacity
    z-index: -1;
    content: "";
    top: 0;
    left: 0;
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    opacity: 0.9;
    background: var(--bb-app-bg-main);
  }
}
</style>
